import { Directive, ElementRef, HostListener, Input, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ZipCodeFormat, ZipConfigService } from '../services/zip-config.service';

@Directive({
  selector: '[appZipFormat]',
})
export class ZipFormatDirective implements OnInit {
  @Input() zipFormatType?: ZipCodeFormat;

  private format: ZipCodeFormat = ZipCodeFormat.ZIP_6_SPACED;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl,
    private zipConfigService: ZipConfigService
  ) {}

  ngOnInit(): void {
    this.format = this.zipFormatType ?? this.zipConfigService.getFormat();
    this.el.nativeElement.maxLength = this.zipConfigService.getMaxLength();
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];

    if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
      return;
    }

    if (this.format === ZipCodeFormat.ZIP_6_SPACED) {
      if (!/^[A-Za-z0-9\s]$/.test(event.key)) {
        event.preventDefault();
      }
      return;
    }

    if (!/^[A-Za-z0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const control = this.ngControl?.control;
    if (control?.value != null && typeof control.value === 'object') {
      return;
    }

    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    const formatted = this.zipConfigService.formatZipInput(pasted, this.format);

    this.el.nativeElement.value = formatted;
    control?.setValue(formatted, { emitEvent: true });
  }

  @HostListener('input')
  onInput(): void {
    const control = this.ngControl?.control;
    if (control?.value != null && typeof control.value === 'object') {
      return;
    }

    const current = this.el.nativeElement.value ?? '';
    const formatted = this.zipConfigService.formatZipInput(current, this.format);

    if (formatted !== current) {
      this.el.nativeElement.value = formatted;
    }

    control?.setValue(formatted, { emitEvent: true });
  }

  @HostListener('blur')
  onBlur(): void {
    const control = this.ngControl?.control;
    if (!control) {
      return;
    }

    const raw = this.zipConfigService.extractZipValue(control.value);
    if (!raw) {
      return;
    }

    const formatted = this.zipConfigService.formatZipInput(raw, this.format);
    if (formatted !== raw && typeof control.value !== 'object') {
      control.setValue(formatted, { emitEvent: true });
    }
  }
}
